import request from '@/config/axios'

export interface BrokerageUserVO {
  id: number
  bindUserId: number
  bindUserTime: Date
  brokerageEnabled: boolean
  brokerageTime: Date
  applyStatus?: number
  applyTime?: Date
  auditTime?: Date
  auditReason?: string
  /** 申请材料：对齐灵工同步/提现必填 */
  applyRealName?: string
  applyIdCard?: string
  applyMobile?: string
  applyBankCardNo?: string
  applyBankName?: string
  /** 申请身份证正面图 URL */
  applyIdCardFrontUrl?: string
  /** 申请身份证反面图 URL */
  applyIdCardBackUrl?: string
  /** 申请人脸图 URL */
  applyFaceUrl?: string
  price: number
  frozenPrice: number

  nickname: string
  avatar: string
}

// 创建分销用户
export const createBrokerageUser = (data: any) => {
  return request.post({ url: '/trade/brokerage-user/create', data })
}

// 查询分销用户列表
export const getBrokerageUserPage = async (params: any) => {
  return await request.get<PageResult<BrokerageUserVO[]>>({
    url: `/trade/brokerage-user/page`,
    params
  })
}

// 查询分销用户详情
export const getBrokerageUser = async (id: number) => {
  return await request.get<BrokerageUserVO>({ url: `/trade/brokerage-user/get?id=` + id })
}

// 修改推广员
export const updateBindUser = async (data: any) => {
  return await request.put({ url: `/trade/brokerage-user/update-bind-user`, data })
}

// 清除推广员
export const clearBindUser = async (data: any) => {
  return await request.put({ url: `/trade/brokerage-user/clear-bind-user`, data })
}

// 修改推广资格
export const updateBrokerageEnabled = async (data: any) => {
  return await request.put({ url: `/trade/brokerage-user/update-brokerage-enable`, data })
}

// 审核分销商申请
export const auditBrokerageUserApply = async (data: {
  id: number
  approved: boolean
  auditReason?: string
}) => {
  return await request.put({ url: `/trade/brokerage-user/audit-apply`, data })
}

// 手动同步灵工会员（仅审核通过）
export const syncFlexworkDistributor = async (id: number) => {
  return await request.post({ url: `/trade/brokerage-user/sync-flexwork`, params: { id } })
}
